/* eslint-disable */

<template>
    <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        width="100%"
        viewBox="0 0 1024 656"
        enable-background="new 0 0 1024 656"
        xml:space="preserve">
        <path
            :fill="color"
            opacity="1.000000"
            stroke="none"
            d="
M329.104309,220.922546
C350.531647,215.082886 371.609558,209.455154 393.189697,206.156174
C406.658569,204.097198 420.229309,202.695068 433.766602,201.102020
C436.194977,200.816254 438.094452,199.965607 439.965515,198.349274
C450.811218,188.980225 465.622620,188.580383 476.734863,197.196762
C487.298584,205.387863 490.558960,219.876846 484.650940,232.375168
C478.906677,244.527008 464.265198,252.732651 451.869415,248.190750
C434.962738,241.996078 418.330994,246.321838 401.601715,246.682602
C390.480682,246.922424 379.390259,248.426773 368.278076,249.257034
C306.204590,253.894897 246.492859,267.217834 191.612701,297.861298
C152.895126,319.480011 120.200363,347.897766 95.765228,385.197479
C83.593819,403.776855 75.959274,424.122589 75.638046,446.548370
C75.420822,461.714081 78.954315,476.368622 85.761589,489.936127
C103.547653,525.385193 130.245712,551.505432 167.386765,566.334778
C174.308960,569.098694 181.581085,570.786499 188.917694,572.175232
C188.526733,574.300049 187.209076,573.674866 186.130096,573.618958
C152.993622,571.903320 124.784950,558.283081 99.656448,537.498657
C66.838173,510.353760 48.418438,474.648071 38.734177,433.869965
C34.289989,415.156525 32.028683,396.146637 33.002449,376.941010
C34.411777,349.144897 38.721203,321.751678 45.445770,294.708679
C54.371590,258.813171 67.029533,224.370682 84.596161,191.799347
C93.380432,175.511917 103.142403,159.802032 113.984520,144.793579
C116.513428,141.292877 117.915924,138.055176 117.209312,133.360352
C115.713913,123.424767 125.322495,112.769012 135.545761,112.087387
C145.135529,111.448006 154.908997,120.823990 155.369232,130.825546
C155.798660,140.157257 151.799164,146.817917 143.803131,151.300781
C141.610779,152.529907 139.621658,153.895630 138.168167,156.087021
C115.033188,190.966766 92.958237,226.406769 76.874153,265.276520
C63.063110,298.653076 52.402069,332.884247 47.659206,368.754120
C46.356216,378.608521 45.854790,388.628876 46.362980,398.640228
C51.289112,333.679138 76.082664,275.916229 110.092110,221.400131
C133.333801,184.144394 161.282990,150.768082 192.395172,119.932114
C201.514511,110.893730 211.154099,102.415947 221.097000,94.305550
C224.437469,91.580742 226.638153,88.616333 227.978531,84.386070
C232.068985,71.476677 245.927643,63.500221 259.172668,65.874855
C271.640015,68.110054 281.720490,80.336716 281.186340,93.140976
C280.710663,104.543991 274.946838,113.071976 264.448334,117.099518
C255.132324,120.673424 247.782211,126.786453 240.376373,132.841660
C200.217697,165.676453 164.022781,202.368561 133.757706,244.629822
C113.745506,272.574280 95.520699,301.620331 81.515396,333.137695
C77.926422,341.214264 75.387627,349.657257 73.003830,358.224304
C75.877411,352.077179 78.653572,345.882263 81.641037,339.791016
C96.548805,309.394897 115.441399,281.601837 137.514374,256.026276
C191.592636,193.366837 254.019989,140.953323 327.453369,102.121796
C342.326172,94.257050 357.017029,86.043442 372.406616,79.213135
C376.107300,77.570679 378.529816,75.294395 380.300720,71.523972
C384.974243,61.573563 396.759888,55.023281 406.805359,56.186066
C419.917908,57.703869 428.854980,64.984734 431.749603,76.507614
C436.420349,95.100945 419.846436,113.972130 401.123566,110.612282
C395.570374,109.615768 391.051697,110.598495 386.269318,112.472435
C353.463318,125.327232 322.063354,141.034622 291.936279,159.274246
C241.601135,189.748306 194.237946,224.185928 152.870163,266.241760
C128.253876,291.267517 107.308228,319.283966 89.439789,349.537659
C87.328064,353.113037 85.661652,356.952209 83.813599,360.681396
C83.600937,361.110535 83.548347,361.618988 84.094620,362.573822
C86.013229,359.697174 88.001762,356.864410 89.839790,353.937134
C111.748970,319.044098 139.755600,289.559631 170.367584,262.269958
C219.640030,218.344925 274.493713,183.096649 334.432800,155.647293
C337.805450,154.102783 340.009369,151.800690 342.028809,148.806854
C348.650513,138.990097 362.246216,134.609619 373.477295,138.390671
C385.193970,142.335190 392.202850,152.113297 391.880737,164.065369
C391.539490,176.727722 383.274506,187.519562 371.457092,190.682831
C329.706604,201.858536 290.414276,218.934631 252.773880,240.008286
C232.248764,251.499588 212.664413,264.438904 193.541443,278.104279
C191.236649,279.751312 189.008896,281.457733 186.464111,284.820343
C233.069458,259.728241 278.901031,235.892838 329.104309,220.922546
M476.632263,222.820969
C477.861969,214.518494 475.008453,208.115982 467.652924,203.938202
C460.024597,199.605453 448.999268,201.694382 443.672363,208.370010
C438.177765,215.255707 438.490082,225.283524 444.352356,231.597504
C451.963379,239.794907 471.809845,240.168198 476.632263,222.820969
M380.407654,169.739182
C380.604401,169.104080 380.825104,168.475266 380.994263,167.832886
C382.775085,161.068542 380.248474,154.505005 374.519440,150.990753
C367.818237,146.880157 359.138702,147.404892 353.574463,152.257019
C347.942871,157.167892 345.881622,164.589661 348.694366,170.641373
C351.625580,176.947876 356.838867,180.498901 363.654877,180.513824
C370.907227,180.529709 376.841431,177.433121 380.407654,169.739182
M255.886307,107.612770
C262.563568,106.169083 267.627991,102.891922 268.728760,95.602005
C269.734222,88.943130 267.551849,83.374298 261.815796,79.712234
C256.134460,76.085098 250.171127,76.229370 244.468811,79.837631
C238.730133,83.468895 236.066925,90.918221 238.042282,97.229202
C240.426590,104.846703 245.211990,107.785507 255.886307,107.612770
M419.479431,87.797752
C421.641022,79.850182 419.261261,73.449524 412.822174,69.892242
C406.263184,66.268723 397.769196,67.755119 392.823517,73.391907
C388.255707,78.598000 387.917694,86.629715 391.799927,92.346390
C396.921906,99.888588 413.499084,100.949203 419.479431,87.797752
M207.313263,195.799850
C205.309692,197.713638 203.306122,199.627426 201.302551,201.541214
C212.836655,192.882462 223.719238,183.596268 235.214493,175.036057
C258.079681,158.008926 281.636169,142.038147 306.321472,127.778557
C328.828766,114.777077 351.850830,102.761009 375.772095,92.523361
C377.263702,91.884987 379.818268,91.411819 378.666107,88.791985
C377.449036,86.024635 375.474670,87.931923 374.044830,88.592766
C337.857880,105.318016 303.129486,124.635872 269.945923,146.766525
C248.004318,161.399719 227.683395,178.045593 207.313263,195.799850
M177.656815,146.159973
C154.041931,171.739166 119.285194,218.824219 115.837746,230.384018
C116.833252,228.923843 117.380554,228.120575 117.928337,227.317642
C140.044418,194.900436 164.817062,164.651962 192.055206,136.408722
C202.477905,125.601425 213.809982,115.773582 224.924271,105.711777
C226.627121,104.170189 228.358322,102.959068 225.557648,100.467232
C208.448090,114.301872 193.158600,129.826263 177.656815,146.159973
M102.068848,175.497772
C98.329124,181.986771 94.413078,188.381363 90.879753,194.980850
C74.293564,225.960205 61.840126,258.540039 53.510502,292.679596
C51.295322,301.758728 49.331596,310.899200 47.252415,320.011505
C61.247192,260.586212 86.251976,205.835220 117.596489,153.706619
C117.161911,153.483490 116.727333,153.260361 116.292755,153.037231
C111.681801,160.320236 107.070854,167.603241 102.068848,175.497772
M249.747055,211.308655
C242.828629,216.040115 235.910202,220.771561 227.849335,226.284332
C231.382019,226.182648 232.753296,224.892670 234.207794,223.941910
C258.088837,208.331451 283.009583,194.604965 308.947662,182.737335
C317.730469,178.718887 326.622223,174.936874 335.493774,171.115524
C337.322601,170.327759 338.868347,169.730576 337.863678,167.186661
C336.812744,164.525513 335.090179,165.433975 333.373199,166.070511
C331.969238,166.591003 330.574615,167.152878 329.222321,167.794373
C302.106628,180.657272 275.629150,194.687607 249.747055,211.308655
M138.571091,122.002602
C133.458862,121.085327 128.911240,123.018333 126.708916,127.044693
C123.826958,132.313568 125.994698,139.217361 131.391586,141.958008
C136.637192,144.621841 143.592453,142.038757 146.088425,136.499832
C148.674149,130.761780 145.995728,125.134964 138.571091,122.002602
M420.427765,217.733307
C429.653015,217.634201 429.931580,217.519363 430.462097,213.193832
C389.293427,215.821854 349.171295,223.247742 310.117157,236.294785
C345.804443,225.583847 382.457275,220.534668 420.427765,217.733307
z"/>
        <path
            :fill="color"
            opacity="1.000000"
            stroke="none"
            d="
M546.012207,154.634140
C548.523438,156.566345 550.789246,156.326233 553.373352,155.645111
C587.967896,146.526917 622.580872,137.478455 657.214478,128.509628
C660.805725,127.579628 662.610291,126.186775 663.178101,122.009689
C665.503967,104.900864 683.214844,96.406021 697.713196,105.190933
C703.660583,108.794655 707.071472,114.233109 707.245850,121.224930
C707.328308,124.534805 708.446045,126.032219 711.675720,126.537292
C741.081787,131.135880 770.482300,135.771317 799.863831,140.523544
C803.191772,141.061829 804.637390,139.217606 806.373413,137.083435
C813.314087,128.551071 823.832336,125.958275 833.254761,130.323044
C843.366272,135.007019 848.375061,146.947617 843.972839,157.203568
C842.371704,160.933685 843.231750,162.814529 846.064636,165.119049
C871.650391,185.932465 897.171631,206.825409 922.639099,227.783310
C924.721252,229.496811 926.183167,229.317856 928.356384,228.039780
C940.576111,220.853134 954.180237,222.754135 962.245667,232.600891
C970.551941,242.741776 970.384277,259.350708 961.414734,269.042114
C955.119690,275.843689 946.906982,278.511688 937.787354,276.893951
C934.133972,276.245880 932.724792,277.398682 931.387756,280.410217
C923.549561,298.065643 915.615967,315.679138 907.601440,333.255249
C906.594482,335.463715 906.699951,337.177612 907.757690,339.326782
C910.970215,345.854370 909.687683,351.981140 904.692627,355.361603
C899.180237,359.092133 891.388184,358.291016 887.077576,353.014465
C884.998779,350.469849 882.411072,349.912903 879.688538,349.492615
C855.221252,345.715240 830.729492,342.096191 806.264526,338.303986
C792.475281,336.166595 778.698181,333.928345 764.967834,331.446289
C760.358398,330.613007 758.903503,332.905457 757.509460,336.561768
C753.169312,347.944946 742.687317,355.134216 731.405640,354.807770
C718.456360,354.433105 707.697449,346.948792 703.656860,335.530853
C702.411804,332.012512 701.798279,328.238098 702.475708,324.727753
C703.432800,319.768402 701.121887,317.935181 697.107422,316.247192
C668.093079,304.047302 639.141663,291.697845 610.176392,279.381531
C599.754944,274.950256 589.308105,270.574280 578.962952,265.970642
C575.811951,264.568451 573.797852,264.834320 571.151611,267.380646
C558.326111,279.721588 538.604797,276.183167 532.010498,260.646118
C530.595825,257.313019 530.259155,253.806931 530.584900,250.353867
C530.920532,246.795334 529.592773,245.234879 526.264099,244.412079
C517.060242,242.137009 507.910645,239.642242 498.742645,237.222824
C496.348419,236.591003 493.520721,236.396240 494.612244,232.560486
C495.501495,229.435715 496.273773,227.028030 500.664001,228.335876
C510.227539,231.184860 519.964478,233.446228 529.581238,236.124969
C532.609192,236.968414 534.890442,236.733963 537.205566,234.305939
C543.955261,227.226929 552.140625,225.125610 561.364563,228.587952
C564.638855,229.816956 566.862793,229.353607 569.340454,226.914139
C573.727722,222.594467 578.378479,218.529755 583.075195,214.542343
C585.458923,212.518616 586.368286,210.539627 584.566833,207.703262
C583.953674,206.737869 583.400940,205.590851 583.285278,204.478516
C582.866699,200.452347 580.411499,200.095612 576.978821,200.116501
C549.983765,200.280823 522.987427,200.223221 495.992004,200.352463
C491.929810,200.371902 489.238953,199.204956 488.587555,194.530838
C492.265717,193.161194 496.069061,193.049301 499.777374,193.030319
C525.599182,192.898148 551.389832,191.728683 577.192627,190.954071
C580.644653,190.850433 582.899048,190.125824 584.748474,186.739166
C590.398865,176.392395 602.752319,172.343124 613.566711,177.299988
C617.080078,178.910370 619.336792,178.390915 622.021973,176.050003
C635.582336,164.227966 649.253113,152.532593 662.835449,140.735535
C664.081482,139.653259 666.554565,138.774384 665.193237,136.482971
C664.041260,134.543930 662.088867,135.978775 660.637024,136.362076
C628.309387,144.896484 596.001648,153.506271 563.690430,162.102707
C562.403137,162.445190 561.137146,162.970963 559.828918,163.112564
C555.601868,163.570099 553.129883,165.376465 551.908691,169.880203
C550.368164,175.561661 545.727539,178.538345 539.930481,178.907288
C534.778748,179.235168 530.532898,177.147934 527.743713,172.554230
C524.847656,167.784485 524.988892,163.059723 527.978333,158.440109
C531.691040,152.702820 538.511108,151.211853 546.012207,154.634140
M863.957703,190.558228
C857.520752,185.282822 850.764160,180.344498 844.739868,174.633789
C839.109375,169.296463 833.687805,166.462067 826.049988,170.502319
C823.855896,171.662964 822.114319,172.439621 821.391235,174.981277
C816.068726,193.690063 810.787964,212.412598 805.210388,231.045868
C803.404724,237.077942 801.618896,242.567856 809.741211,245.216232
C810.324036,245.406281 810.880615,245.974030 811.239441,246.507385
C814.350342,251.131165 818.875854,251.049728 823.669250,250.454453
C842.983337,248.055908 862.437134,247.337555 881.816223,245.712921
C892.086914,244.851852 902.373657,244.182388 912.653809,243.435318
C916.022644,243.190475 918.026672,241.435486 919.184448,238.244690
C920.455017,234.742889 917.523926,233.849884 915.780212,232.432999
C898.728455,218.576935 881.598755,204.816895 863.957703,190.558228
M664.728699,247.337250
C637.060242,250.517853 609.391724,253.698456 581.723267,256.879059
C620.135803,274.257141 658.492676,290.351746 696.732300,306.720245
C703.003601,309.404663 707.887512,310.794403 712.902832,304.179840
C715.011902,301.398224 716.394897,299.618591 715.502380,296.160004
C712.179504,283.282623 708.739502,270.421234 705.975830,257.419464
C704.444702,250.216080 695.451782,251.931168 693.456909,245.709518
C693.172119,244.821381 691.975525,244.378113 690.902344,244.447952
C690.077820,244.501556 689.265808,244.724640 688.441956,244.814926
C680.843811,245.647568 673.244263,246.467697 664.728699,247.337250
M676.534485,218.837021
C681.107361,220.372162 685.661621,221.965942 690.260254,223.419724
C692.885193,224.249557 695.589905,225.806305 698.219238,223.339447
C700.634460,221.073471 698.876221,218.519485 698.380615,216.330597
C693.427368,194.455780 688.286621,172.623276 683.161499,150.787598
C681.147522,142.206848 676.241821,140.590149 669.484009,146.389969
C655.721680,158.201431 642.136353,170.221390 628.259155,181.895203
C625.293213,184.390198 623.963806,186.438507 625.564453,190.233078
C626.507385,192.468567 627.381897,195.281693 626.843567,197.481796
C625.631348,202.436386 628.542419,203.442673 632.078186,204.568359
C646.656067,209.209549 661.206726,213.936279 676.534485,218.837021
M793.963440,148.639679
C783.966187,147.043884 773.969360,145.445602 763.971680,143.852844
C745.789795,140.956207 727.607117,138.064041 709.425415,135.166153
C707.777161,134.903442 705.988220,134.379471 704.999084,136.290802
C704.092468,138.042725 705.731201,139.061279 706.578918,140.146088
C720.912354,158.487549 735.376892,176.727341 749.595215,195.157242
C752.107910,198.414246 753.834412,198.217743 756.766052,195.908676
C770.612244,185.002975 784.455383,174.082062 798.616699,163.594772
C802.564636,160.671066 802.270935,157.931244 801.514160,153.869873
C800.711853,149.564087 798.008423,149.181076 793.963440,148.639679
M810.978455,307.565460
C796.565247,312.340729 782.151978,317.116028 766.416931,322.329254
C769.209534,323.040619 770.473511,323.470001 771.773010,323.677246
C787.694702,326.216156 803.620972,328.726562 819.547302,331.236298
C839.911499,334.445435 860.272827,337.673035 880.648499,340.807861
C882.459167,341.086456 884.669312,342.149231 886.007690,339.675964
C887.492737,336.931580 885.187195,335.697784 883.721191,334.302490
C871.294006,322.474884 858.776367,310.742218 846.378296,298.884399
C844.387756,296.980560 842.562866,296.826019 840.091003,297.694092
C830.672302,301.001678 821.194397,304.140503 810.978455,307.565460
M672.153320,226.466736
C657.149719,221.537582 642.143738,216.615814 627.145203,211.671341
C624.872437,210.922104 622.949280,210.403229 620.873047,212.626205
C615.616089,218.254639 608.440491,221.363495 601.427551,219.009933
C592.381042,215.973953 588.018555,221.302063 582.775085,226.135712
C580.206360,228.503647 577.644409,230.879974 575.028748,233.195267
C573.824829,234.260818 572.749023,235.392014 573.761108,237.018097
C575.879517,240.421768 576.575928,244.393509 578.178711,248.269348
C615.963379,243.436981 653.761536,240.124298 691.397949,234.287369
C685.542603,230.318939 679.010864,229.073242 672.153320,226.466736
M718.250366,275.453857
C719.876160,282.064209 721.617920,288.649200 723.072205,295.297058
C723.676819,298.060669 724.957703,298.963470 727.609253,298.254883
C732.482300,296.952728 737.257935,297.790741 741.772522,299.566895
C744.521362,300.648346 746.310669,300.326355 748.386597,298.264160
C754.878906,291.814880 761.427429,285.410065 768.205017,279.264648
C772.469177,275.398163 775.286865,271.958344 773.098572,265.336975
C771.828674,261.494690 770.675232,259.380127 766.885620,258.307495
C755.852356,255.184540 744.807129,252.068619 733.912476,248.503967
C727.333740,246.351456 721.489014,244.334213 715.696106,250.718201
C713.746521,252.866699 712.745605,254.238647 713.405090,256.819336
C714.925659,262.770172 716.478638,268.712769 718.250366,275.453857
M914.432678,272.036957
C893.927429,279.172302 873.422119,286.307648 852.401550,293.622284
C853.422058,294.816620 853.882446,295.469635 854.452637,296.005829
C866.818848,307.635498 879.165833,319.286072 891.592651,330.850769
C895.347168,334.344818 898.752258,333.604279 900.969971,328.782532
C908.340393,312.757446 915.693237,296.722443 922.804321,280.581757
C924.034302,277.790039 927.329529,274.868378 924.700256,271.469391
C921.671631,267.553955 918.353210,271.652405 914.432678,272.036957
M698.345093,182.319916
C701.003784,193.805573 703.595398,205.307419 706.359375,216.767685
C707.266357,220.528168 716.658752,225.012329 719.695801,222.886169
C728.503662,216.719864 737.041077,210.167023 745.578003,203.844742
C744.535095,200.804230 742.732483,199.034103 741.208435,197.088730
C728.380615,180.714066 715.493225,164.385818 702.726196,147.963898
C697.763306,141.580200 697.883057,141.487091 689.721985,145.385925
C692.534180,157.330292 695.378662,169.412125 698.345093,182.319916
M807.710510,195.329666
C809.680176,188.456131 811.732788,181.604660 813.571167,174.696198
C814.154175,172.505692 815.709595,170.153397 812.379089,168.219696
C809.337341,166.453735 807.221741,167.112473 804.768311,169.058350
C793.818054,177.743210 782.809082,186.354111 771.799805,194.964249
C767.371826,198.427277 762.888672,201.819687 758.616943,205.101074
C758.771912,205.932953 758.725281,206.341171 758.906677,206.561859
C767.676575,217.227325 776.353821,227.972336 785.310181,238.479309
C788.752930,242.518021 794.645630,241.009506 796.141357,235.908813
C800.023926,222.668457 803.762146,209.385788 807.710510,195.329666
M886.589966,272.980652
C896.789917,269.482758 906.989868,265.984894 917.356628,262.429779
C916.957153,260.718262 916.502319,259.461975 916.392639,258.176208
C915.983398,253.381058 913.927429,252.105194 908.904541,252.836639
C899.544250,254.199707 890.033569,254.558578 880.578125,255.233490
C860.840210,256.642395 841.097778,257.987488 821.356506,259.349365
C820.012695,259.442078 818.591492,259.404816 817.931702,260.875885
C817.134033,262.654236 818.460205,263.712585 819.530701,264.699982
C827.116028,271.696259 834.776245,278.611633 842.329346,285.642334
C844.016235,287.212524 845.533447,287.446594 847.704956,286.666595
C860.390991,282.109741 873.129517,277.699127 886.589966,272.980652
M785.153748,280.633972
C782.235474,278.654907 780.049744,279.675598 777.756042,281.996033
C770.845764,288.986755 764.069824,296.162323 756.641113,302.569702
C751.917480,306.643982 755.192627,309.233459 756.795410,312.711578
C758.764832,316.985565 761.554260,315.144989 764.298096,314.251892
C780.917664,308.842560 797.537292,303.432922 814.137268,297.963989
C821.172852,295.646057 828.352356,293.680359 835.608887,290.278717
C828.812439,283.458771 822.468811,277.258240 815.710510,271.607086
C803.210999,282.840332 796.949158,284.741425 785.153748,280.633972
M766.379700,248.965363
C767.484924,249.329773 768.639465,249.588501 769.686646,250.077286
C773.809021,252.001526 776.317200,249.603027 778.565918,246.746979
C780.924194,243.751770 777.875000,242.202484 776.489258,240.488190
C769.801086,232.214386 762.964111,224.060318 756.135925,215.900574
C754.584412,214.046509 753.634766,211.559296 750.844666,210.597046
C742.829407,216.437180 734.773499,222.280014 726.753174,228.171158
C724.929077,229.511032 722.760864,230.594131 723.513062,233.672668
C724.217712,236.556519 726.120361,237.573059 728.699341,238.292191
C741.014893,241.726318 753.299316,245.272034 766.379700,248.965363
z"/>
        <path
            :fill="color"
            opacity="1.000000"
            stroke="none"
            d="
M278.000061,381.698425
C288.663757,381.700806 298.828217,381.626953 308.990906,381.729462
C318.064026,381.820923 320.059692,384.048859 318.447968,392.942993
C313.025116,422.868408 307.412292,452.759308 301.908997,482.670227
C299.022827,498.356903 296.037903,514.029236 293.483521,529.770630
C292.777344,534.122375 290.660950,536.143494 286.727112,536.182983
C272.733795,536.323486 258.735382,536.393616 244.744949,536.145996
C239.786743,536.058228 238.673950,534.034485 239.781509,528.160828
C243.168320,510.200043 246.717468,492.269867 250.162155,474.319885
C253.294052,457.999908 256.359222,441.667175 259.482574,425.345551
C260.247375,421.348907 258.894714,419.361359 254.607391,419.383026
C240.445312,419.454559 226.281784,419.483795 212.120590,419.346558
C207.861938,419.305298 206.877502,421.742859 206.281006,425.224487
C201.678833,452.086151 197.008499,478.936218 192.310043,505.781281
C190.820282,514.293213 189.103592,522.765686 187.646973,531.283020
C187.020172,534.948120 184.945023,536.312073 181.435104,536.302307
C167.106186,536.262329 152.776123,536.382080 138.448547,536.237488
C132.314178,536.175598 131.171768,534.481873 132.292725,528.454895
C138.642914,494.312531 144.987213,460.169067 151.337616,426.026733
C152.364731,420.504578 151.556641,419.464722 145.997391,419.399628
C141.665833,419.348907 137.332870,419.324219 133.001541,419.374451
C129.184647,419.418732 127.195168,417.547302 127.822151,413.830902
C129.342117,404.821381 131.048264,395.839691 132.881866,386.888245
C133.694382,382.921661 136.941223,381.852295 140.499405,381.777100
C145.995560,381.660889 151.496857,381.632324 156.993011,381.731079
C160.019455,381.785461 161.468246,380.752472 161.836090,377.521454
C162.981506,367.460907 164.219330,357.443115 167.610886,347.754028
C178.401535,316.926971 204.233749,297.236572 236.606720,294.519653
C253.576813,293.095428 270.139282,293.883026 286.444916,298.864258
C287.718201,299.253204 288.984222,299.674927 290.229309,300.145691
C299.771790,303.753876 300.292542,305.297455 295.276764,314.077179
C291.476471,320.729279 287.730377,327.414551 284.088867,334.154602
C280.653320,340.513336 280.052277,340.868134 273.212158,337.655029
C266.143005,334.334412 258.828522,332.773895 250.982880,332.902588
C236.317200,333.143188 225.990143,339.986450 219.535156,352.879211
C215.699158,360.540955 214.068481,368.912323 212.442657,377.250214
C211.599121,381.576172 214.377335,381.738098 217.519257,381.730865
C237.512772,381.684723 257.506439,381.702332 278.000061,381.698425
z"/>
        <path
            :fill="color"
            opacity="1.000000"
            stroke="none"
            d="
M393.723358,538.200439
C369.769714,538.588867 346.310120,538.470825 322.967194,535.356079
C315.586060,534.371155 313.983704,532.407227 315.290161,525.164429
C320.982971,493.603973 326.874329,462.078125 332.363617,430.482391
C338.420593,395.618835 344.786041,360.804443 349.788422,325.762756
C350.844482,318.365112 352.482605,311.051788 353.609192,303.662537
C354.270142,299.327209 356.537231,296.976532 360.840302,296.947723
C375.003723,296.852875 389.168365,296.827667 403.331818,296.905212
C407.924530,296.930328 410.066071,299.520599 409.291016,304.066498
C407.616028,313.891144 405.868561,323.704895 404.015747,333.497528
C400.462921,352.275726 396.798615,371.032837 393.241302,389.810211
C392.958649,391.302124 391.600311,393.169922 393.615967,394.334167
C395.418274,395.375214 396.733917,393.772522 398.032257,392.834991
C414.321869,381.072296 432.710876,378.793182 451.865570,381.783966
C474.219666,385.274292 489.080475,400.892548 492.182190,424.682953
C495.777374,452.258698 488.071686,477.158051 471.422729,499.197144
C453.346283,523.125793 428.731842,535.078552 399.132111,537.426270
C397.477600,537.557556 395.840607,537.909424 393.723358,538.200439
M432.142426,474.628571
C436.685699,465.368713 439.037292,455.625305 438.655701,445.270111
C437.924866,425.437164 421.717804,414.618835 403.249603,421.617828
C391.632751,426.020355 384.971558,434.640076 382.581421,446.538269
C379.869141,460.039917 377.698120,473.650177 374.999573,487.154816
C374.344696,490.432190 375.457031,492.135834 377.956451,493.689728
C386.799957,499.187836 396.422455,500.091461 406.305115,498.001038
C419.001617,495.315430 426.322418,486.260193 432.142426,474.628571
z"/>
        <path
            :fill="color"
            opacity="1.000000"
            stroke="none"
            d="
M687.296509,442.906525
C688.448975,451.486267 689.578674,459.616943 690.758423,468.108093
C693.786560,466.671753 694.216309,464.382812 695.117188,462.529358
C706.328552,439.463501 717.825500,416.526001 728.461365,393.196381
C732.466797,384.410492 737.949219,380.824036 747.405579,381.588837
C757.672363,382.419189 768.055237,380.828033 778.313843,382.446503
C784.563171,383.432495 785.709351,385.447235 782.824890,391.256500
C778.679688,399.604828 774.135437,407.758026 769.659546,415.938690
C749.198792,453.335388 728.892395,490.818451 708.146057,528.056274
C696.135986,549.613220 681.426575,569.120361 661.046204,583.655823
C642.276245,597.042847 621.231995,600.441101 598.784546,597.383240
C594.643005,596.819031 593.487061,593.930969 593.856873,590.580017
C595.005066,580.176208 596.486633,569.811523 599.177979,559.659912
C600.161255,555.950806 603.190125,556.159546 605.955872,555.939026
C613.076233,555.371216 620.311096,556.519714 627.343140,554.692566
C640.099609,551.378113 647.751892,542.544983 651.951660,530.650574
C653.447937,526.412903 651.055725,521.848572 650.323120,517.480225
C645.211853,487.003448 639.880127,456.563660 634.633362,426.109558
C632.489380,413.665283 630.528259,401.186890 628.169983,388.783691
C627.425110,384.866058 628.885986,383.103149 632.302856,382.268982
C633.582214,381.956665 634.924255,381.759613 636.238586,381.754486
C647.567505,381.710236 658.897583,381.632629 670.225403,381.746979
C678.321411,381.828705 679.910645,383.190948 680.917114,391.017853
C683.120483,408.153503 685.164551,425.309692 687.296509,442.906525
z"/>
        <path
            :fill="color"
            opacity="1.000000"
            stroke="none"
            d="
M775.570251,425.671570
C797.356384,390.083221 829.428406,376.408356 869.804199,379.487305
C885.247131,380.664917 899.597473,384.454895 912.071472,394.102112
C924.369019,403.612793 930.825256,416.497986 933.182861,431.425659
C939.669861,472.498962 910.154419,521.029480 868.887085,533.549255
C845.597595,540.614929 821.907837,541.212280 798.687927,533.254700
C778.486572,526.331543 767.553528,511.306824 764.627502,490.343872
C761.478210,467.781219 764.689880,446.255341 775.570251,425.671570
M863.309509,488.802887
C874.535583,475.455780 879.533630,460.002411 878.873779,442.652588
C878.436584,431.155975 872.548401,422.024475 863.654846,418.956238
C852.541138,415.122070 839.099548,418.219330 832.191956,426.933472
C820.811951,441.290039 815.218811,457.750977 816.436401,476.150360
C817.229858,488.141541 824.267761,495.682709 836.057617,498.117615
C846.656860,500.306641 855.319397,496.576691 863.309509,488.802887
z"/>
        <path
            :fill="color"
            opacity="1.000000"
            stroke="none"
            d="
M561.108032,450.141663
C556.157654,460.214081 555.428589,470.966797 553.343872,481.362671
C550.142578,497.326233 547.126465,513.330139 544.311035,529.365967
C543.415894,534.464172 540.776184,536.384460 535.859802,536.345093
C523.361328,536.245117 510.860901,536.384827 498.362732,536.269043
C491.790192,536.208191 490.111755,534.069763 491.362793,527.463440
C496.897430,498.236420 502.547180,469.031189 508.073364,439.802551
C511.066895,423.969330 513.892334,408.104401 516.800659,392.255066
C518.459473,383.215240 520.180603,381.743347 529.414246,381.717896
C539.746582,381.689423 550.084717,381.538483 560.409851,381.822205
C568.936523,382.056519 570.103882,383.746307 569.170288,392.207733
C568.671692,396.726501 566.512634,401.092712 567.730591,406.294128
C570.558105,404.920319 571.838013,402.542786 573.348999,400.520142
C584.580811,385.484467 599.408020,378.808105 618.149719,380.827057
C625.046326,381.570007 626.537292,383.360687 625.269287,390.099609
C623.178650,401.210175 621.137207,412.329987 619.037659,423.438843
C618.009888,428.877228 616.697388,429.608673 611.146606,428.978638
C604.908630,428.270599 598.780640,427.141174 592.323792,427.997101
C578.007385,429.894958 568.317017,437.832031 561.108032,450.141663
z"/>
        <path
            :fill="color"
            opacity="1.000000"
            stroke="none"
            d="
M471.684052,109.417618
C490.923920,101.478462 509.557495,111.773804 511.961548,131.872040
C513.063171,141.081650 509.729034,149.217880 502.157043,155.220032
C493.373383,162.182632 483.485931,163.708832 473.577515,159.096420
C467.918091,156.461914 462.847809,156.522324 457.285980,157.722183
C443.299866,160.739426 429.341949,163.867172 415.676758,168.169174
C413.785736,168.764496 411.854980,169.413956 409.811493,168.713562
C405.729858,167.314606 403.650879,164.156799 402.996490,160.190704
C402.345306,156.243851 405.769073,155.186249 408.446350,154.063705
C422.163971,148.312149 436.495331,144.622284 451.044708,141.705597
C452.986786,141.316269 454.915619,140.860840 456.991394,140.405106
C457.745728,135.986740 455.697235,135.480667 452.251068,136.378845
C437.593170,140.199188 422.949310,144.049057 408.886169,149.798477
C407.256592,150.464722 405.533417,151.672684 403.686188,150.513412
C402.068512,149.498215 401.084412,147.906921 400.877686,145.998520
C400.647308,143.871567 402.407440,143.203690 403.869446,142.480057
C414.524353,137.206223 425.876862,133.916458 437.309540,130.888199
C443.093140,129.356247 448.915710,127.965408 454.743683,126.609947
C456.777039,126.137024 457.852264,124.853821 458.576477,123.063026
C461.067139,116.904221 465.507843,112.587807 471.684052,109.417618
M489.918976,148.635895
C501.761597,142.975922 504.200989,129.520721 494.738983,122.049454
C488.361603,117.013832 480.077087,116.948204 474.039978,121.885475
C468.350037,126.538849 466.520752,134.493942 469.689941,140.802658
C473.267273,147.923813 480.373383,150.846985 489.918976,148.635895
z"/>
        <path
            :fill="color"
            opacity="1.000000"
            stroke="none"
            d="
M290.038208,279.244202
C285.312469,279.228333 281.182129,280.989227 276.669617,280.499939
C284.583923,271.818573 368.893036,260.372375 407.716522,261.750885
C492.335999,264.755432 570.288391,289.173889 642.406372,332.914673
C639.763367,334.256317 637.912598,332.562683 635.991211,331.614929
C593.712158,310.760651 549.506470,295.214020 503.758148,284.096283
C482.746674,278.990051 461.337219,275.962585 439.761047,274.228943
C423.678314,272.936737 407.585388,271.072571 391.458466,271.529633
C361.360565,272.382629 331.294739,274.085876 301.408203,278.063599
C297.781738,278.546265 294.129211,278.833130 290.038208,279.244202
z"/>
        <path
            :fill="color"
            opacity="1.000000"
            stroke="none"
            d="
M851.284912,557.702393
C859.057129,553.701965 866.310913,553.514465 872.913025,559.290466
C874.849915,560.984985 876.077637,560.087585 877.728699,559.142029
C883.509827,555.831116 889.606506,553.939880 896.356018,555.501404
C903.606995,557.178955 907.383057,561.261292 907.095459,568.962708
C906.679565,580.097717 903.891357,590.963440 902.111938,601.942932
C901.996643,602.654297 901.327454,603.740540 900.768372,603.842407
C895.999817,604.711365 891.139832,604.774048 886.429688,603.799622
C884.456726,603.391479 885.209290,601.063049 885.481018,599.435242
C886.739441,591.896057 887.931519,584.345276 889.249878,576.816650
C889.889771,573.162537 890.271545,569.210938 885.984314,568.045105
C881.923706,566.940979 879.093079,569.940491 877.454956,573.413330
C874.567139,579.535645 874.422729,586.332092 873.425415,592.869080
C871.598755,604.842957 869.654602,606.374573 857.626953,604.303467
C854.248291,603.721619 854.885437,601.625610 855.239075,599.475525
C856.505920,591.773132 857.768066,584.069641 859.087769,576.376160
C859.662292,573.026611 859.492371,569.893127 856.057678,568.210876
C852.568787,566.502075 849.958191,568.672791 847.677551,570.905029
C844.662964,573.855652 843.969299,577.866211 843.315308,581.822632
C842.285950,588.050415 841.202332,594.271423 840.324585,600.520996
C839.961243,603.107849 838.919312,604.439331 836.186523,604.353577
C832.859131,604.249146 829.526611,604.293762 826.196350,604.294250
C823.533081,604.294617 822.734009,602.977417 823.166138,600.441589
C825.399231,587.338562 827.597595,574.229431 829.738281,561.110962
C830.309631,557.609558 832.058167,555.481750 835.730957,556.042114
C839.993835,556.692505 845.193970,553.658325 848.415039,559.026611
C848.472046,559.121643 850.096436,558.276184 851.284912,557.702393
z"/>
        <path
            :fill="color"
            opacity="1.000000"
            stroke="none"
            d="
M820.302185,577.831848
C818.152283,601.050781 796.361084,611.063843 776.846436,603.495239
C767.433350,599.844482 763.760193,589.027100 767.121460,577.137451
C772.047119,559.714294 792.476929,549.884705 809.076111,557.130005
C817.835938,560.953491 821.023376,568.150146 820.302185,577.831848
M802.893860,576.742920
C801.605103,568.269226 795.299255,565.709595 788.725586,571.097656
C784.116943,574.875061 782.271484,579.859741 783.231873,585.749146
C784.132507,591.271851 789.353149,594.019043 794.482849,591.649780
C800.435547,588.900391 802.853577,583.927979 802.893860,576.742920
z"/>
        <path
            :fill="color"
            opacity="1.000000"
            stroke="none"
            d="
M745.257324,592.803345
C750.803711,593.599609 754.665405,589.894043 759.269287,588.682129
C760.953247,599.815674 757.691650,604.024414 747.152344,605.446472
C741.071838,606.266846 735.159119,606.042542 729.539368,603.699097
C720.844116,600.072998 717.156738,591.752991 718.767273,580.295532
C721.455994,561.168396 746.615173,548.425049 763.824097,557.443542
C766.558838,558.876770 767.912720,560.729797 766.645264,563.879944
C765.613892,566.443298 765.596436,569.455566 763.158203,571.651062
C759.753540,570.594238 756.855103,568.226868 753.030396,568.016846
C744.668457,567.557617 737.653259,572.945801 736.389526,581.257263
C735.386536,587.853882 738.091919,591.544495 745.257324,592.803345
z"/>
        <path
            :fill="color"
            opacity="1.000000"
            stroke="none"
            d="
M694.217407,593.498230
C697.373718,589.752686 701.062378,588.993469 705.209045,590.244934
C708.195923,591.146301 709.851990,593.345093 710.203979,596.401611
C710.652283,600.294678 709.717407,603.693298 705.988831,605.669556
C702.291321,607.629211 698.503784,607.621399 695.408325,604.683472
C692.171875,601.611816 691.762329,597.800964 694.217407,593.498230
z"/>
        <path
            :fill="color"
            opacity="1.000000"
            stroke="none"
            d="
M293.790100,87.860992
C292.003784,84.365036 292.254059,81.394485 294.622498,78.774178
C297.368317,75.736351 302.476410,75.105095 305.432617,77.560913
C308.713440,80.286377 309.053436,83.743240 307.031403,87.371735
C304.951996,91.103287 300.709076,92.304634 296.703217,90.335426
C295.698669,89.841599 294.897736,88.933617 293.790100,87.860992
z"/>
        <path
            :fill="color"
            opacity="1.000000"
            stroke="none"
            d="
M459.364624,172.812744
C460.503571,178.683167 456.998047,182.428558 452.368378,180.789139
C449.836426,179.892563 448.145721,178.107864 447.935852,175.382843
C447.771149,173.244125 448.817078,171.555237 450.839691,170.644241
C454.052734,169.197037 456.926178,169.444748 459.364624,172.812744
z"/>
        <path
            :fill="color"
            opacity="1.000000"
            stroke="none"
            d="
M389.115662,130.137482
C386.277710,129.248718 384.754974,127.630798 384.843872,124.962654
C384.913239,122.881889 386.394501,121.691605 388.180267,121.050407
C390.297852,120.290062 392.119598,121.130699 393.534668,122.714996
C396.216217,125.717148 394.548035,128.775192 389.115662,130.137482
z"/>
    </svg>
</template>

<script>
    export default {
        props: {
            color: { type: String, default: 'black' }
        }
    }
</script>
